import { isElectron } from './electron';

export const isMacOs = (): boolean => {
    if (isElectron && (window as any).electronApi?.isMac) {
        return (window as any).electronApi.isMac;
    }

    return typeof navigator !== 'undefined' && /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
};
